export const pagesData = [
  {
    id: 1,
    pages: "Home",
    page_slug: "home",
    status: "Active",
    key: "1"
  },
  {
    id: 2,
    pages: "About Us",
    page_slug: "about-us",
    status: "Inactive",
    key: "2"
  },
  {
    id: 3,
    pages: "FAQ",
    page_slug: "faq",
    status: "Active",
    key: "3"
  },
  {
    id: 4,
    pages: "Categories",
    page_slug: "categories",
    status: "Active",
    key: "4"
  },
  {
    id: 5,
    pages: "Terms & Conditions",
    page_slug: "terms-conditions",
    status: "Active",
    key: "5"
  },
  {
    id: 6,
    pages: "Privacy Policy",
    page_slug: "privacy policy",
    status: "Active",
    key: "6"
  },
  {
    id: 7,
    pages: "Contact US",
    page_slug: "contact-us",
    status: "Active",
    key: "7"
  },
];
